import React, { useState,useEffect} from 'react';
import './InputAndSelectCompo.css';

const InputAndSelectCompoBoxSmall = ({ 
  label, 
  options, 
  defaultValue = '', 
  defaultOption='',
  onChange, 
  selectchange,
  border='',
  className='',
  validators = [], 
  type = 'text', 
  error,
}) => {

  const [value, setValue] = useState(defaultValue);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [errors, setErrors] = useState([]);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() =>{
    setValue(defaultValue)
    setSelectedOption(defaultOption)
  },[defaultValue,defaultOption])

  useEffect(() => {
    const newErrors = [];
  
    if (validators?.length > 0) {
      validators.forEach((validator) => {
        const result = validator(value);
        if (result !== true) newErrors.push(result);
      });
    }
    if (!hasInteracted) return;
    // Always validate selectedOption with isRequired
    if (selectedOption === "" || selectedOption === null || selectedOption === undefined) {
      newErrors.push("Please select an option");
    }
  
    setErrors(newErrors);
  }, [value, selectedOption]);
  

  const handleInputChange = (event) => {
    setValue(event.target.value);
    setHasInteracted(true);
    if (onChange) {
      onChange(event);
    }
  };

  const handleSelectChange = (event) => {
    
    setSelectedOption(event.target.value);
    setHasInteracted(true);
    if (selectchange) {
      selectchange(event); 
    }
  };

  const displayErrors = error ? [error] : errors;

  return (
    <div className={`small-compo-box-container ${className} ${displayErrors.length > 0 ? 'mb-20' : ''} ${border}`}>
      <select
        value={selectedOption}
        onChange={handleSelectChange}
        className='fts-13'
      > 
        <option value="" disabled hidden></option>
        {options.map((option, index) => (
          <option className='fts-13' key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <input
        className={`input-box compo-box-input common-text fts-13 ${type === 'date' ? 'input-box-with-icon' : ''}
        } ${errors.length > 0 ? 'input-error' : ''}`}
        type={type}
        value={value}
        onChange={handleInputChange}
        placeholder=' '
      />

      <label className={`lt-gray fixed-input-label ${value ? 'has-value' : ''}`}>
        {label}
      </label>
      {displayErrors.length > 0 && (
        <div className="input-error-message compo-box-error fts-12">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default InputAndSelectCompoBoxSmall;



// const InputAndSelectCompoBoxSmall = ({
//   label,
//   defaultValue = '',
//   defaultOption = '',
//   options,
//   onChange,
//   className='',
//   name,
//   type = 'text',
//   validators = [],
//   isRequired = false,
//   error,
// }) => {
//   const [inputValue, setInputValue] = useState(defaultValue);
//   const [selectedCurrency, setSelectedCurrency] = useState(defaultOption || options[0]?.value || '');
//   const [errors, setErrors] = useState([]);

//   useEffect(() => {
//     setInputValue(defaultValue);
//     setSelectedCurrency(defaultOption || options[0]?.value || '');
//   }, [defaultValue, defaultOption, options]);

//   const effectiveValidators = isRequired
//     ? [...validators, (val) => (val ? true : 'This field is required')]
//     : validators;

//   const validateInput = (value) => {
//     const newErrors = effectiveValidators
//       .map((validator) => {
//         const result = validator(value);
//         return result === true ? null : result;
//       })
//       .filter((error) => error);

//     setErrors(newErrors);
//     return newErrors;
//   };

//   const handleInputChange = (event) => {
//     const newValue = event.target.value;
//     setInputValue(newValue);

//     const newErrors = validateInput(newValue);

//     if (onChange) {
//       onChange(name, {
//         price: newValue,
//         currency: selectedCurrency,
//       });
//     }
//   };

//   const handleSelectChange = (event) => {
//     const newCurrency = event.target.value;
//     setSelectedCurrency(newCurrency);

//     if (onChange) {
//       onChange(name, {
//         price: inputValue,
//         currency: newCurrency,
//       });
//     }
//   };

//   const displayErrors = error ? [error] : errors;

//   return (
//     <div className={`small-compo-box-container ${className}`}>
//       <select
//         value={selectedCurrency}
//         onChange={handleSelectChange}
//         className="fts-13 border-none"
//       >
//         {options.map((option, index) => (
//           <option className="fts-13" key={index} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </select>
//       <input
//         className={`input-box compo-box-input border-none common-text fts-13 ${
//           errors.length > 0 ? 'input-error' : ''
//         }`}
//         type={type}
//         value={inputValue}
//         onChange={handleInputChange}
//         placeholder=""
//         name={name}
//       />
//       <label className={`lt-gray fixed-input-label ${inputValue ? 'has-value' : ''}`}>
//         {label}
//       </label>
//       {displayErrors.length > 0 && (
//         <div className="input-error-message">
//           {displayErrors[0]}
//         </div>
//       )}
//     </div>
//   );
// };

// export default InputAndSelectCompoBoxSmall;





